<template>
  <div class="head-tabs">
    <ul class="nav nav-tabs" role="tablist">
      <template v-for="tab in tabs">
        <template v-if="permission.hasAccess(tab.access)">
          <template v-if="tab.name == 'Customized Transaction History'">
            <template
              v-if="
                merchantUuid == 'aa1c538b-df7e-4654-be6e-d7e6f5977d53' ||
                merchantUuid == '6e277127-5e4b-48aa-a15c-0e1757d3a5a2'
              "
            >
              <li class="nav-item" role="presentation" :key="tab.index">
                <router-link
                  :to="tab.href"
                  class="nav-link"
                  :class="{ active: tabLinkActive(tab.href), 'link-disabled': 'enabled' in tab ? !tab.enabled : false }"
                  role="tab"
                  >
                  {{ tab.name }}
                  <span v-if="'beta' in tab ? tab.beta : false" class="beta text-uppercase bg-primary text-white rounded px-1"><small>Beta</small></span>
                </router-link
                >
              </li>
            </template>
          </template>
          <template v-else>
            <li class="nav-item" role="presentation" :key="tab.index">
              <router-link
                :to="tab.href"
                class="nav-link"
                :class="{ active: tabLinkActive(tab.href), 'link-disabled': 'enabled' in tab ? !tab.enabled : false }"
                role="tab"
                >
                {{ tab.name }}
                <span v-if="'beta' in tab ? tab.beta : false" class="beta text-uppercase bg-primary text-white rounded px-1"><small>Beta</small></span>
              </router-link
              >
            </li>
          </template>
        </template>
      </template>
    </ul>
  </div>
</template>
<script>
import permission from "@/services/user.permission";
export default {
  data() {
    return {
      permission: permission,
    };
  },
  props: {
    tabs: Array,
    merchantUuid: String,
  },
  methods: {
    tabLinkActive(path) {
      return path === this.$route.path || this.$route.path.includes('fulfillment') && this.$route.path.includes(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.link-disabled {
  pointer-events: none;
  cursor: not-allowed;
}
</style>
